import { useSyncExternalStore } from 'react';

export const optionalCookiesAllowed = () => typeof window !== 'undefined'
    && window.A1Consent?.allowed() === true;

const subscribe = (listener) => {
    window.addEventListener('a1-consent-change', listener);

    return () => window.removeEventListener('a1-consent-change', listener);
};

export const useOptionalCookies = () => useSyncExternalStore(subscribe, optionalCookiesAllowed, () => false);
